import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

if ($('.txt-regio__wrapper__maps').length) {
  var latlng = new mapboxgl.LngLat(
    $('.txt-regio__wrapper__maps div#mapbox-marker').attr('data-lng'),
    $('.txt-regio__wrapper__maps div#mapbox-marker').attr('data-lat')
  );

  // Make a new mapbox
  mapboxgl.accessToken =
    'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOHd3a2E3cjAwdXIzbnF2YW5rbGg2MjUifQ._4tX77HzoIe0CAWJhMvm0A';
  var map = new mapboxgl.Map({
    container: 'mapboxWrapperRegio',
    style: 'mapbox://styles/blackdesk/cl8wwl6nr002115qudeey6z1e',
    attributionControl: false,
    center: latlng,
    maxZoom: 18,
    minZoom: 7,
    zoom: 9.8,
  });

  var markers = [];
  var lat = [];
  var lng = [];

  $('.txt-regio__wrapper__maps div#mapbox-marker').each(function () {
    var markerll = new mapboxgl.LngLat(
      $(this).attr('data-lng'),
      $(this).attr('data-lat')
    );
    var lati = $(this).attr('data-lat');
    var lngi = $(this).attr('data-lng');
    lat.push(lati);
    lng.push(lngi);

    //Define marker
    var el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(' + $(this).attr('data-image') + ')';
    el.style.width = '30px';
    el.style.height = '30px';
    el.style.backgroundSize = 'contain';

    // add marker to map
    new mapboxgl.Marker(el).setLngLat(markerll).addTo(map);
    //Push the marker into the markers array
    markers.push(el);

    // get the permalink
    var permalink = $(this).attr('data-permalink');

    // Link to permalink of location
    $(el).on('click', function (e) {
      e.stopPropagation();
      window.location.href = permalink;
    });
  });
}

if ($('.txt-regio__maps').length) {
  latlng = new mapboxgl.LngLat(
    $('.txt-regio__maps div#mapbox-marker').attr('data-lng'),
    $('.txt-regio__maps div#mapbox-marker').attr('data-lat')
  );

  // Make a new mapbox
  mapboxgl.accessToken =
    'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOHd3a2E3cjAwdXIzbnF2YW5rbGg2MjUifQ._4tX77HzoIe0CAWJhMvm0A';
  map = new mapboxgl.Map({
    container: 'mapboxRegio',
    style: 'mapbox://styles/blackdesk/cl8wwl6nr002115qudeey6z1e',
    attributionControl: false,
    center: latlng,
    maxZoom: 18,
    minZoom: 7,
    zoom: 10,
  });

  markers = [];
  lat = [];
  lng = [];

  $('.txt-regio__maps div#mapbox-marker').each(function () {
    var markerll = new mapboxgl.LngLat(
      $(this).attr('data-lng'),
      $(this).attr('data-lat')
    );
    var lati = $(this).attr('data-lat');
    var lngi = $(this).attr('data-lng');
    lat.push(lati);
    lng.push(lngi);

    //Define marker
    var el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = 'url(' + $(this).attr('data-image') + ')';
    el.style.width = '45px';
    el.style.height = '45px';
    el.style.backgroundSize = 'contain';

    // add marker to map
    new mapboxgl.Marker(el).setLngLat(markerll).addTo(map);
    //Push the marker into the markers array
    markers.push(el);

    // get the permalink
    var permalink = $(this).attr('data-permalink');

    // Link to permalink of location
    $(el).on('click', function (e) {
      e.stopPropagation();
      window.location.href = permalink;
    });
  });
}

if ($('.contact__maps').length) {
  const marker = $('#mapbox-marker-contact');

  if (marker.attr('data-lng')) {
    var markerPosition = new mapboxgl.LngLat(
      marker.attr('data-lng'),
      marker.attr('data-lat')
    );
    mapboxgl.accessToken =
      'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOHd3a2E3cjAwdXIzbnF2YW5rbGg2MjUifQ._4tX77HzoIe0CAWJhMvm0A';

    map = new mapboxgl.Map({
      container: 'mapboxWrapperContact',
      style: 'mapbox://styles/blackdesk/cl8wwl6nr002115qudeey6z1e',
      attributionControl: false,
      center: markerPosition,
      maxZoom: 18,
      minZoom: 6,
      zoom: 16,
    });

    var el = document.createElement('div');
    el.className = 'marker-custom';
    el.style.backgroundImage =
      'url(/wp-content/themes/hdmakelaardij/public/images/marker.svg)';

    new mapboxgl.Marker(el).setLngLat(markerPosition).addTo(map);

    map.on('load', function () {
      map.resize();
    });
  }
}

if ($('.rw-maps').length) {
  const marker = $('#mapbox-marker-object');

  if (marker.attr('data-lng')) {
    markerPosition = new mapboxgl.LngLat(
      marker.attr('data-lng'),
      marker.attr('data-lat')
    );
    mapboxgl.accessToken =
      'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsOHd3a2E3cjAwdXIzbnF2YW5rbGg2MjUifQ._4tX77HzoIe0CAWJhMvm0A';

    map = new mapboxgl.Map({
      container: 'mapboxWrapperObject',
      style: 'mapbox://styles/blackdesk/cl8wwl6nr002115qudeey6z1e',
      attributionControl: false,
      center: markerPosition,
      maxZoom: 18,
      minZoom: 6,
      zoom: 16,
    });

    el = document.createElement('div');
    el.className = 'marker-custom';
    el.style.backgroundImage =
      'url(/wp-content/themes/hdmakelaardij/public/images/marker.svg)';

    new mapboxgl.Marker(el).setLngLat(markerPosition).addTo(map);
  }
}

$(function () {
  if (map) {
    map.scrollZoom.disable();
    map.on('load', function () {
      map.resize();
    });
  }
});
